export default "__VITE_ASSET__coh4mhtP__"